import { useEffect, useRef } from 'react';
import { useHandleLogout } from '../utils/useHandleLogout';

export const useInactivityLogout = (isAuthenticated: boolean, timeoutDuration: number = 30 * 60 * 1000) => {
  const { handleLogout } = useHandleLogout();
  const timeoutRef = useRef<number | null>(null);

  const handleActivity = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = window.setTimeout(() => {
      handleLogout();
    }, timeoutDuration);
  };

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keypress', handleActivity);
    window.addEventListener('click', handleActivity);
    window.addEventListener('scroll', handleActivity);

    handleActivity();

    return () => {
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keypress', handleActivity);
      window.removeEventListener('click', handleActivity);
      window.removeEventListener('scroll', handleActivity);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isAuthenticated, handleLogout, timeoutDuration]);
};
